import {
  BaseQueryApi,
  FetchArgs,
  fetchBaseQuery,
  retry,
} from "@reduxjs/toolkit/dist/query/react";
import { RootState } from "../index";

export const staggeredBaseQuery = (path: string) =>
  retry(
    async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) => {
      const apiUrl = process.env.REACT_APP_API_URL;
      let result = await fetchBaseQuery({
        baseUrl: `${apiUrl}/${path}`,
        prepareHeaders: async (headers, { getState }) => {
          const token = (getState() as RootState).auth.idToken;
          if (token === null) {
            return headers;
          }
          headers.set("Authorization", `Bearer ${token}`);
          return headers;
        },
      })(args, api, extraOptions);
      return result;
    },
    {
      maxRetries: 3,
    }
  );
